import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantContextService } from '@core/tenant/tenant-context.service';
import { SKIP_TENANT_HEADERS } from '@core/http/public-catalog-http.context';

export const tenantCompanyInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_TENANT_HEADERS)) {
    return next(req);
  }

  const companyId = inject(TenantContextService).activeCompanyId();
  if (!companyId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Company-Id': String(companyId),
      },
    })
  );
};
